/* Shopify-Chat-/Inbox-Icon liegt über Warenkorb- und Filter-Slider
   (Desktop + Mobile). Das Widget kommt je nach Shopify-Version unter
   unterschiedlichen IDs/Tags ins DOM (#ShopifyChat, #shopify-chat,
   #chat-app, #shopifyChatSDK, #dummy-chat-button-iframe, das Custom-
   Element <inbox-online-store-chat> u.a.) und manche Varianten setzen
   ihre Inline-Styles per eigener Dauerschleife immer wieder zurück.
   Deshalb hier bewusst breit + wiederholt statt einmalig:
   - display:none (nicht nur visibility) greift auch gegen ein Kind-
     Element, das sich selbst wieder auf "visible" setzt
   - viele bekannte Selektor-Varianten gleichzeitig
   - kurzes Poll-Intervall, solange ein Drawer offen ist, damit ein
     etwaiges Reset-Skript des Widgets keine Chance hat */
(() => {
  'use strict';

  if (window.DftChatFixReady) return;
  window.DftChatFixReady = true;

  const SELECTORS = [
    '#ShopifyChat',
    '#shopify-chat',
    '#chat-app',
    '#shopifyChatSDK',
    '#dummy-chat-button-iframe',
    '#chat-button-container',
    'inbox-online-store-chat',
    'shopify-chat',
    '[id*="shopify-chat" i]',
    '[id*="ShopifyChat" i]',
    '[class*="chat-app" i]',
  ].join(', ');

  const OPEN_CLASSES = ['overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet', 'overflow-hidden-desktop'];

  const istOffen = () => OPEN_CLASSES.some((cls) => document.body.classList.contains(cls));

  const anwenden = () => {
    const offen = istOffen();
    document.querySelectorAll(SELECTORS).forEach((el) => {
      if (offen) {
        el.style.setProperty('display', 'none', 'important');
      } else if (el.style.getPropertyValue('display') === 'none') {
        el.style.removeProperty('display');
      }
    });
  };

  let pollId = null;
  const pollStarten = () => {
    if (pollId) return;
    pollId = setInterval(anwenden, 250);
  };
  const pollStoppen = () => {
    if (!pollId) return;
    clearInterval(pollId);
    pollId = null;
  };
  const pollPruefen = () => {
    if (istOffen()) {
      pollStarten();
    } else {
      pollStoppen();
      anwenden();
    }
  };

  /* Body-Klasse ändert sich (Drawer auf/zu) -> sofort reagieren + Polling steuern */
  const klassenBeobachter = new MutationObserver(pollPruefen);
  klassenBeobachter.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  /* Widget kann erst nachladen, oder erst NACH dem Öffnen eines
     Sliders im DOM auftauchen -> laufend beobachten. */
  const domBeobachter = new MutationObserver(anwenden);
  domBeobachter.observe(document.documentElement, { childList: true, subtree: true });

  anwenden();
  pollPruefen();
})();
